import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Manual recovery path: visit `?reset-app=1` to clear caches & SW once.
// Avoids the white-page loop caused by purging on every load.
(async () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("reset-app") === "1") {
      if ("serviceWorker" in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.map((n) => caches.delete(n)));
      }
      params.delete("reset-app");
      const qs = params.toString();
      window.location.replace(window.location.pathname + (qs ? `?${qs}` : ""));
      return;
    }

    // In preview/iframe contexts, proactively unregister any leftover SW so
    // a previously-cached worker doesn't intercept navigation.
    const isInIframe = (() => {
      try {
        return window.self !== window.top;
      } catch {
        return true;
      }
    })();
    const host = window.location.hostname;
    const isPreviewHost =
      host.includes("id-preview--") ||
      host.includes("lovableproject.com") ||
      host.includes("lovable.app");
    if ((isInIframe || isPreviewHost) && "serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      if (regs.length > 0) {
        await Promise.all(regs.map((r) => r.unregister()));
      }
    }
  } catch (e) {
    console.warn("Pre-mount cleanup skipped:", e);
  }
})();

try {
  const root = document.getElementById("root");
  if (root) {
    createRoot(root).render(<App />);
  } else {
    console.error("Root element not found");
  }
} catch (err) {
  console.error("Fatal render error:", err);
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML = `<div style="padding:40px;text-align:center;font-family:system-ui">
      <h1>Something went wrong</h1>
      <p style="color:#666">${err instanceof Error ? err.message : "Unknown error"}</p>
      <button onclick="location.href='/?reset-app=1'" style="margin-top:16px;padding:8px 24px;cursor:pointer">Reload &amp; reset</button>
    </div>`;
  }
}
